import { render, staticRenderFns } from "./ResetSms.vue?vue&type=template&id=6e44ebc2&"
import script from "./ResetSms.vue?vue&type=script&lang=js&"
export * from "./ResetSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n/translations/reset.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Falgoritmika_org%2Fdevelopment%2Fservice%2Fauth%2Ffrontend%2Fsrc%2Fpages%2FResetSms.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "../i18n/translations/codePage.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Falgoritmika_org%2Fdevelopment%2Fservice%2Fauth%2Ffrontend%2Fsrc%2Fpages%2FResetSms.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports